import React from 'react';
import PropTypes from 'prop-types'
import '../QueuePage.scss'
import HrbTranslate from '../../../components/language/HrbTranslate';
import HelpLink from '../../../components/library/common/HelpLink';
import Skeleton from '../../../components/library/loaders/Skeleton';

const TicketQueueHeader = ({ isAssociateQueue, associateFullName }) => (
    <div className="columns">
        <div className='column is-7 ml-5'>
            <h3>
                {!isAssociateQueue &&
                    <HrbTranslate text='QueuePage.Labels.TicketsAssigned' />
                }
                {isAssociateQueue && associateFullName &&
                    <HrbTranslate text='QueuePage.Labels.AssociateTicketsAssigned' params={{ FullName: associateFullName }} />
                }
            </h3>         
        </div>
        <div className='column is-2' style={{ marginLeft:'25%' }}>
            <HelpLink helpKey='0ProSupport/VDOPro/HomePage.htm' />
        </div>
    </div>
);

TicketQueueHeader.propTypes = {
    isAssociateQueue: PropTypes.bool,
    associateFullName: PropTypes.string
}

export default TicketQueueHeader